export default "__VITE_ASSET__CGgw_jxG__"